import React, { useEffect, useState } from 'react';
import { Button, Flex, Input } from 'antd';
import { Outlet, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import { Page } from '../../../../../shared/ui/Page';
import { ShopList } from '../components/ShopList';
import { useLazyReadShopsQuery } from '../service/shops';
import { shopsFilters } from '../utils/shopList.filters';
import { useProfileData } from '../../../../../hooks/useProfileData';
import { Shop } from '../service/shop.interface';
import { OnboardingCard } from '../components/Onboarding/OnboardingCard';
import { ExampleShopCard } from '../components/ExampleShopCard';
import { useAppDispatch } from '../../../../../store';
import { setShopList } from '../store/shopSlice';

export const ShopsPage = () => {
    const [getShops, { data: shops, isFetching, isLoading, isSuccess }] =
        useLazyReadShopsQuery();
    const { user } = useProfileData();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const [filters, setFilters] = useState<Shop>(shopsFilters);

    useEffect(() => {
        const current = dayjs(new Date()).unix();

        if (user) {
            if (user.subscription?.expiration_date < current) {
                return navigate('/pay/subscription');
            }
        }
    }, [user]);

    const isTelegramAccount = user?.telegram_accounts?.length > 0;

    useEffect(() => {
        if (filters) {
            getShops(filters, false);
        }
    }, [filters]);

    useEffect(() => {
        if (isSuccess && shops) {
            dispatch(setShopList(shops.items));
        }
    }, [shops, isSuccess]);

    const loading = isLoading || isFetching;
    const isShops = !!shops?.items;

    return (
        <>
            <Page title={'Магазины'}>
                <OnboardingCard />
                <Flex vertical gap={16}>
                    <Flex
                        justify={
                            isTelegramAccount
                                ? 'space-between'
                                : 'space-between'
                        }
                        align={'center'}
                    >
                        {isTelegramAccount && (
                            <>
                                <div>
                                    <Input
                                        allowClear
                                        onChange={e =>
                                            setFilters({
                                                ...filters,
                                                name: e.target.value,
                                            })
                                        }
                                        placeholder={'Поиск магазина'}
                                    />
                                </div>

                                <Button
                                    loading={isLoading}
                                    disabled={isLoading}
                                    onClick={() => navigate('create')}
                                    type={'primary'}
                                >
                                    Создать магазин
                                </Button>
                            </>
                        )}
                    </Flex>

                    {!isTelegramAccount && isShops && <ExampleShopCard />}

                    {!isTelegramAccount && !isShops ? null : (
                        <ShopList
                            filters={filters}
                            setFilters={setFilters}
                            loading={loading}
                            data={shops}
                        />
                    )}
                </Flex>
            </Page>
            <Outlet />
        </>
    );
};
